const state = {
    info: null,
};

const actions = {};

const mutations = {
    SAVE_CLIENT_INFO(state, payload) {
        state.info = payload.data;
    },
    RESET_CLIENT_INFO(state) {
        state.info = null;
    }
};

export default {
    state,
    actions,
    mutations
}
